import { userDataService } from '../../services/userData';

export function getUser (email, tokenPartners) {
	return {
		type: 'GET_USER',
		payload: userDataService(email, tokenPartners)
	}
}